import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import '../../skeleton/skeleton/index.esm.js';
import '../../skeleton/skeleton-block/index.esm.js';
import { EGDSLineSkeleton } from '../../skeleton/skeleton-line/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-date-range.css';
import '../types/index.esm.js';
import { EGDSDateRangeButton } from '../date-range-button/index.esm.js';
import { EGDSDateRangeGetSelectedDateScrollCenterDistance } from '../date-range-util-functions/index.esm.js';
import { applyFade } from '../utils/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSDateRange = ({
  loading,
  loadingMessage,
  results
}) => {
  const baseClassName = 'uitk-date-range';
  const buttonClassName = `${baseClassName}-button`;
  const scrollMouse = {
    move: false,
    initialMousePos: 0,
    buttonLeft: 0
  };
  const dateRangeRef = useRef(null);
  const getSelectedDateResultsIndex = () => results.findIndex(resultObj => resultObj.selected);
  const selectedDateIndex = getSelectedDateResultsIndex();
  const buttonScroll = parent => {
    if (parent.currentTarget) {
      applyFade(parent.currentTarget);
    }
  };
  let resizeTimeout;
  const mouseDown = ev => {
    scrollMouse.move = true;
    scrollMouse.initialMousePos = ev.clientX;
    scrollMouse.buttonLeft = ev.currentTarget.scrollLeft;
  };
  const mouseUp = () => {
    scrollMouse.move = false;
  };
  const mouseMove = ev => {
    if (scrollMouse.move) {
      // eslint-disable-next-line no-param-reassign
      ev.currentTarget.scrollLeft = scrollMouse.buttonLeft + scrollMouse.initialMousePos - ev.clientX;
      buttonScroll(ev);
    }
  };
  const onWindowResize = () => {
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        const dateRangeEl = dateRangeRef && dateRangeRef.current;
        const selectedDateScrollCenterDistance = EGDSDateRangeGetSelectedDateScrollCenterDistance(dateRangeEl, selectedDateIndex);
        dateRangeEl && (dateRangeEl.scrollLeft = selectedDateScrollCenterDistance);
        resizeTimeout = null;
        applyFade(dateRangeRef.current);
      }, 200);
    }
  };
  useEffect(() => {
    const dateRangeEl = dateRangeRef && dateRangeRef.current;
    const selectedDateScrollCenterDistance = EGDSDateRangeGetSelectedDateScrollCenterDistance(dateRangeEl, selectedDateIndex);
    dateRangeEl && (dateRangeEl.scrollLeft = selectedDateScrollCenterDistance);
    applyFade(dateRangeRef.current);
    window.addEventListener('resize', onWindowResize);
    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, []);
  return jsxs("div", {
    className: getClassNameList(`${baseClassName}-container`),
    children: [loading && loadingMessage && jsx("span", {
      className: "is-visually-hidden",
      children: loadingMessage
    }), jsxs("ul", {
      ref: dateRangeRef,
      role: "tablist",
      className: getClassNameList(baseClassName),
      onScroll: buttonScroll,
      onMouseDown: mouseDown,
      onMouseUp: mouseUp,
      onMouseMove: mouseMove,
      onMouseLeave: mouseUp,
      children: [!loading && results.map((result, index) => {
        const buttonName = `${buttonClassName}-${index}`;
        return jsx("li", {
          className: getClassNameList(`${baseClassName}-button-wrapper-natural`),
          role: "presentation",
          children: jsx(EGDSDateRangeButton, {
            className: getClassNameList(buttonClassName),
            result: result
          })
        }, buttonName);
      }), loading && [...Array(7)].map((_, index) => jsx("li", {
        className: getClassNameList('uitk-date-range-loading-cell'),
        role: "tab",
        children: jsx(EGDSLineSkeleton, {})
      }, `uitk-date-range-loading-cell-${index}`))]
    })]
  });
};
export { EGDSDateRange };